import * as FullStory from '@fullstory/browser';

export const strict = false;
export const type = 'cookie-consent';

export const GET_CONSENT_RESPONSE = 'GET_CONSENT_RESPONSE';
export const LOAD_STORED_RESPONSE = 'LOAD_STORED_RESPONSE';
export const SUBMIT_COOKIE_BANNER = 'SUBMIT_COOKIE_BANNER';
const SET = 'SET';
const SET_CONSENT = 'SET_CONSENT';
const INJECT_ANALYTICS_SCRIPTS = 'INJECT_ANALYTICS_SCRIPTS';
const ANALYTICS_SCRIPTS_INITIALIZED = 'ANALYTICS_SCRIPTS_INITIALIZED';
const LOADED_FROM_STORAGE = 'LOADED_FROM_STORAGE';

const STORAGE_KEY = 'demodesk_booking_page_cookie_consent';
const CONSENT_GIVEN_DAYS_UNTIL_EXPIRY = 365;
const CONSENT_DECLINED_DAYS_UNTIL_EXPIRY = 1;

const GTM_DEMODESK_DATA_LAYER = 'demodeskDataLayer';
const GTM_DEMODESK_CODE = 'GTM-PFZ4GZ8';
const FULLSTORY_ORG_ID = 'V355R';

// Object of customer and event type slugs, we currently hardcode GTM for
const CUSTOMER_GTM_MAPPING = {
  'demodesk-gmbh': {
    eventTypes: [],
    tagManagerCode: GTM_DEMODESK_CODE,
    dataLayer: GTM_DEMODESK_DATA_LAYER
  },
  comtravo: {
    eventTypes: ['webdemo-de'],
    tagManagerCode: 'GTM-PSQK84K'
  },
  'myskillcamp-team': {
    eventTypes: [],
    tagManagerCode: 'GTM-5WGGH5N'
  }
};

export const state = () => ({
  consent: {
    consentGiven: false,
    timestamp: null
  },
  loadedFromLocalStorage: false,
  analyticsScriptsInitialized: false
});

export const actions = {
  [LOAD_STORED_RESPONSE]({
    getters, state, commit, dispatch
  }) {
    if (state.loadedFromLocalStorage === false) {
      const loadedConsent = loadFromStorage();
      if (loadedConsent !== undefined) {
        commit(SET_CONSENT, loadedConsent);
        commit(LOADED_FROM_STORAGE);
        if (state.consent.consentGiven === true) {
          dispatch(INJECT_ANALYTICS_SCRIPTS);
        }
      }
    }
  },
  [SUBMIT_COOKIE_BANNER]({
    getters, state, commit, dispatch
  }, { consentGiven }) {
    commit(SET_CONSENT, {
      consentGiven: consentGiven,
      timestamp: new Date().getTime()
    });
    if (consentGiven === true) {
      dispatch(INJECT_ANALYTICS_SCRIPTS);
    }
    writeIntoStorage(state);
  },
  [INJECT_ANALYTICS_SCRIPTS]({ getters, state, commit }) {
    if (state.analyticsScriptsInitialized === true) {
      return;
    }
    initFullStory();
    initCustomerGoogleTagManager();
    commit(ANALYTICS_SCRIPTS_INITIALIZED, true);
  }
};

export const mutations = {
  [SET](state, data) {
    state = data;
  },
  [SET_CONSENT](state, consentData) {
    state.consent = consentData;
  },
  [LOADED_FROM_STORAGE](state, data) {
    state.loadedFromLocalStorage = true;
  },
  [ANALYTICS_SCRIPTS_INITIALIZED](state, data) {
    state.analyticsScriptsInitialized = true;
  }
};

export const getters = {
  [GET_CONSENT_RESPONSE](state, getters) {
    return state.consent;
  }
};

const writeIntoStorage = (state) => {
  try {
    // we call stringify twice to easily escape quotes
    const serializedConsent = JSON.stringify(JSON.stringify(state.consent));
    localStorage.setItem(STORAGE_KEY, serializedConsent);
  } catch (err) {
    console.warn('writing the cookie consent to localstorage', err);
  }
};

const loadFromStorage = () => {
  try {
    const loadedString = localStorage.getItem(STORAGE_KEY);
    if (!loadedString) {
      return undefined;
    }
    const parsed = JSON.parse(JSON.parse(loadedString));
    const expiryDays = parsed.consentGiven ? CONSENT_GIVEN_DAYS_UNTIL_EXPIRY : CONSENT_DECLINED_DAYS_UNTIL_EXPIRY;
    const expiryDate = parsed.timestamp + expiryDays * 24 * 60 * 60 * 1000;
    const isExpired = new Date().getTime() > expiryDate;
    if (isExpired) {
      localStorage.removeItem(STORAGE_KEY);
      return undefined;
    }
    return parsed;
  } catch (err) {
    console.warn('error loading the cookie consent', err);
  }
  return undefined;
};

const initFullStory = () => {
  FullStory.init({ orgId: FULLSTORY_ORG_ID, devMode: process.env.NODE_ENV !== 'production' });
  window.$nuxt.$FullStory = FullStory;
};

const injectGoogleTagManagerSnippet = (tagManagerCode, dataLayer = 'dataLayer') => {
  const googleTagManager = document.createElement('script');
  const googleTagManagerNoScript = document.createElement('noscript');
  googleTagManager.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','${dataLayer}','${tagManagerCode}');`;
  googleTagManagerNoScript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${tagManagerCode}"
  height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.head.appendChild(googleTagManager);
  document.body.appendChild(googleTagManagerNoScript);
};

const initCustomerGoogleTagManager = () => {
  const { slug, event_type_slug: eventTypeSlug } = window.$nuxt.$route.params;

  if (slug in CUSTOMER_GTM_MAPPING) {
    const { eventTypes, dataLayer } = CUSTOMER_GTM_MAPPING[slug];
    if (eventTypes.length === 0 || eventTypes.includes(eventTypeSlug)) {
      injectGoogleTagManagerSnippet(CUSTOMER_GTM_MAPPING[slug].tagManagerCode, dataLayer);
    }
  }
};
